import { render, staticRenderFns } from "./CourseManage.vue?vue&type=template&id=72dba5d9&scoped=true&lang=pug&"
import script from "./CourseManage.vue?vue&type=script&lang=ts&"
export * from "./CourseManage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseManage.vue?vue&type=style&index=0&id=72dba5d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dba5d9",
  null
  
)

export default component.exports